<template>
<div class="content-page">
    <div class="content">
        <div class="container-fluid">
            <div class="row mt-4">
                <div class="col-sm-12">
                    <div class="text-center">
                        <h3>자주 묻는 질문</h3>
                        <p class="text-muted mt-3">
                            고시락 CEO 페이지에 대한 고시원 사장님들이 자주 묻는 질문을 모아놓은 공간입니다.
                            <br />이 외에 질문들은 문의하기를 이용해 주시기 바랍니다 : )
                        </p>
                        <button type="button" class="btn btn-success btn-sm mt-2" @click="goToMypage()">
                            <i class="mdi mdi-email-outline me-1"></i> 문의하기
                        </button>
                    </div>
                </div>
            </div>
            <div class="row pt-5">
                <div class="col-lg-5 offset-lg-1">
                    <div v-for="(faq, idx) in left_faqList" :key="`left_faq_${idx}`">
                        <div class="faq-question-q-box">Q.</div>
                        <h4 class="faq-question" data-wow-delay=".1s">{{ faq.title }}</h4>
                        <p class="faq-answer mb-4">{{ faq.sub_title }}</p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div v-for="(faq, idx) in right_faqList" :key="`right_faq_${idx}`">
                        <div class="faq-question-q-box">Q.</div>
                        <h4 class="faq-question" data-wow-delay=".1s">{{ faq.title }}</h4>
                        <p class="faq-answer mb-4">{{ faq.sub_title }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    INFORMATION
} from "@/config/const.js";

export default {
    data() {
        return {
            faqList: []
        };
    },
    computed: {
        left_faqList() {
            return this.faqList.filter((_, idx) => idx % 2 === 0);
        },
        right_faqList() {
            return this.faqList.filter((_, idx) => idx % 2 === 1);
        },
    },
    async mounted() {
        try {
            const res = await this.axios.get("/faq");
            this.faqList = res.data.result;
        } catch (error) {
            console.log(error);
        }
    },
    methods: {
        goToMypage() {
            this.$router.push({
                path: "/mypage"
            });
        },
        sendMail() {
            // 기존 이메일 문의에서 -> 마이 페이지 내 문의로 이동
            window.location.href = `mailto:${INFORMATION.EMAIL}`;
        }
    }
}
</script>
